<template>
    <div class="well ovx-auto">
        <div class="flex-level">
            <div class="flex fs-4 bold">
                {{ $l10n.__('Avoirs') }}
            </div>
            <div class="flex aright">
                <CompassButton
                    :label="$t.__('common.actions.impact_profit')"
                    type="secondary"
                    :disabled="impactButtonIsDisable"
                    @click="impact()"
                />
            </div>
        </div>

        <el-table ref="multipleTable" :data="creditnotes" @selection-change="handleSelectionChange">
            <el-table-column type="selection" :selectable="canProcess" property="processMargin">
            </el-table-column>
            <el-table-column :label="$t.__('common.labels.impact_profit')">
                <template #default="scope">
                    {{ displaySaasBoolean(scope.row.processMargin) }}
                </template>
            </el-table-column>
            <el-table-column :label="$t.__('common.labels.date')">
                <template #default="scope">
                    {{ $filters.saasDateFormatted(scope.row.date) }}
                </template>
            </el-table-column>
            <el-table-column :label="$t.__('common.labels.document')">
                <template #default="scope">
                    <a v-if="scope.row.canRead" :href="buildLink(scope.row.docid)">
                        {{ scope.row.ident }}
                    </a>
                    <span v-else>
                        {{ scope.row.ident }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                property="formatted_totalAmountTaxesFree"
                :label="$t.__('common.labels.amount_excluding_tax')"
            >
            </el-table-column>
        </el-table>

        <div v-if="creditnotes.length > 0" class="aright fs-3 mt-2">
            {{ $l10n.__('Total impact') }} : {{ $filters.numberFormatCurrency(formattedTotal) }}
        </div>
    </div>
</template>

<script>
import MarginMixins from './MarginMixins.js';
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('documentOverview');

export default {
    mixins: [MarginMixins],
    data() {
        return {
            context: 'creditnote',
        };
    },
    computed: {
        formattedTotal: function () {
            if (this.original.length == 0) {
                return 0;
            }
            return this.original.reduce((accumulator, doc) => {
                return accumulator + parseFloat(doc.totalAmountTaxesFree);
            }, 0);
        },
        ...mapState({
            creditnotes: (state) => state.creditnotes,
            original: (state) => state.creditnotes.filter((link) => link.processMargin === true),
        }),
    },
    methods: {
        buildLink: function (docid) {
            return `?_f=creditnoteOverview&id=${docid}`;
        },
    },
};
</script>
